import { BehaviorSubject } from 'rxjs';
import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { BecareService } from '../services/becare.service';
import { EHealthService } from '../services/e-health.service';
import { UserConfigService } from '../services/user-config.service';
import { SNItemTableControl, SNItemTableService, SNItemTableServiceCapability } from '../snitem-table/snitem-table-interface';
import { CNItem } from './cnitem';
import { CNPrescriptionEntry } from './cnprescriptionentry';
import * as moment from 'moment';

@RegisterItem()
export class CNPrescription extends CNItem {

    private entriesCache: CNPrescriptionEntry[];

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNPrescription';
    }

    get prescriptionDate(): Date {
        if (this.getProperty('PrescriptionDate')) {
            return moment(this.getProperty('PrescriptionDate'), 'DD/MM/YYYY').toDate();
        }
        return this.createddate;
    }

    public get rid() {
        return (this.getProperty('rid')) ? this.getProperty('rid') : undefined;
    }

    public get error() {
        return (this.getProperty('EHealthError')) ? this.getProperty('EHealthError') : undefined;
    }

    public get status() {
        return (this.getProperty('EHealthStatus')) ? this.getProperty('EHealthStatus') : undefined;
    }

    get entries(): CNPrescriptionEntry[] {
        if (this.entriesCache) {
            return this.entriesCache;
        }
        return this.childs$('SNItem.CNItem.CNPrescriptionEntry') as CNPrescriptionEntry[];
    }

    /**
     * ItemContainer interface
     * @returns string
     */

    get title(): string {
        return moment(this.prescriptionDate).format('DD/MM/YYYY');
    }

    public clone(): any {
        return new CNPrescription();
    }

    /**
     * JSON
     */

     public fromJson(json: any, emitLoaded?: boolean): void {
        super.fromJson(json, emitLoaded);
        if (typeof json.entries !== 'undefined' && Array.isArray(json.entries) && json.entries.length !== 0) {
            // entries
            this.entriesCache = [];
            json.entries.forEach(jsonEntry => {
                const entry = new CNPrescriptionEntry();
                entry.fromJson(jsonEntry);
                this.entriesCache.push(entry);
            });
        }
    }

    public toObj(deep = false): any {
        const obj = super.toObj(deep);
        const entries = this.entries;
        if (entries) {
            obj.entries = [];
            entries.forEach(anEntry => {
                obj.entries.push(anEntry.toObj(deep));
            });
        }
        return obj;
    }

}
